import { createFeature, createReducer } from '@ngrx/store';

import { newOpportunityAddInventoryReducers } from './new-opportunity-add-inventory.reducer';
import { newOpportunityAddInventoryInitialState } from './new-opportunity-add-inventory.state';

export const newOpportunityAddInventoryFeature = createFeature({
    name: 'newOpportunityAddInventory',
    reducer: createReducer(newOpportunityAddInventoryInitialState, ...newOpportunityAddInventoryReducers),
});
